<template>
	<c-dialog
		ref="dialog"
		:title="dialogTitle"
		width="85vw"
		mode="slide"
		enable-flex
		mask-close
		:button="false"
	>
		<c-table ref="productList" height="grow" :paging="{ size: 20 }">
			<c-table-column label="存货编码" name="inventory_code" width="120" :ellipsis="true"></c-table-column>
			<c-table-column label="存货名称" name="inventory_name" min-width="140" :ellipsis="true"></c-table-column>
			<c-table-column label="规格型号" name="spec_model" width="120" :ellipsis="true"></c-table-column>
			<c-table-column label="长（mm）" name="length" width="90">
				<template #default="{ data }">{{ fmtNum(data.length) }}</template>
			</c-table-column>
			<c-table-column label="宽（mm）" name="width" width="90">
				<template #default="{ data }">{{ fmtNum(data.width) }}</template>
			</c-table-column>
			<c-table-column label="数量" name="quantity" width="80">
				<template #default="{ data }">{{ fmtNum(data.quantity) }}</template>
			</c-table-column>
			<c-table-column label="件数" name="pieces" width="80">
				<template #default="{ data }">{{ fmtNum(data.pieces) }}</template>
			</c-table-column>
            <c-table-column label="总工时数" name="pieces" width="80">
                <template #default="{ data }">{{ fmtHour(data.total_work_hours) }}</template>
            </c-table-column>
			<c-table-column label="单条平均工时" name="avg_work_hours" width="100">
				<template #default="{ data }">{{ fmtHour(data.avg_work_hours) }}</template>
			</c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'engineerPerformanceProductDetail',

	computed: {
		...mapState(['connectionMethodDic'])
	},

	data() {
		return {
			dialogTitle: '安装产品工时详情'
		};
	},

	methods: {
		open(data) {
			if (!data) {
				data = {};
			}
			this.dialogTitle = `${data.engineer_name || ''}-安装产品工时详情`;
			this.$refs.dialog.open();
			this.$nextTick(() => {
				this.$refs.productList.load({
					url: '/engineer/performance/product/list',
					data: data.query || {},
					success: () => {}
				});
			});
		},

		fmtNum(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return v;
		},

		fmtHour(v) {
			if (v === null || v === undefined || v === '') {
				return '-';
			}
			return `${v}h`;
		}
	}
};
</script>
